/**
 * The fallback terminal's copy is the platform's, not the graph generator's:
 * every serving seam stamps the node's `label` from the rule's `onEmpty`
 * setting ("Hide the upsell" / "Show smart recommendations"), so the card
 * renders the stamped label. This constant is only the floor for a graph
 * that somehow arrives label-less — it must never override a stamp, or a
 * smart-recs rule's canvas would claim the slot hides.
 */
export const FALLBACK_TERMINAL_BODY = "Hide the upsell";
